import {
  API_OFFERING_INDICATE_INTEREST,
  API_OFFERING_WATCH_CANCEL_INDICATION,
  replacePlaceholders,
} from './urls';
import callWebApi from './callWebApi';

export const INDICATE_INTEREST = 'INDICATE_INTEREST';
export const INDICATE_INTEREST_FAILURE = 'INDICATE_INTEREST_FAILURE';
export const INDICATE_INTEREST_SUCCESSFUL = 'INDICATE_INTEREST_SUCCESSFUL';
export const CANCEL_INDICATION = 'CANCEL_INDICATION';
export const CANCEL_INDICATION_FAILURE = 'CANCEL_INDICATION_FAILURE';
export const CANCEL_INDICATION_SUCCESSFUL = 'CANCEL_INDICATION_SUCCESSFUL';

export const indicateInterest = offerId => async (dispatch, getState) => {
  const reduxState = getState();
  let firstName;
  let lastName;
  let email;
  let phone;
  let state;
  let userId;
  const { authToken } = reduxState;
  const {
    investmentRange,
  } = reduxState.indicateInterestForm.indicateInterest;
  if (reduxState.user.data) {
    userId = reduxState.user.data.id;
    ({ firstName } = reduxState.user.data.identity);
    ({ lastName } = reduxState.user.data.identity);
    ({ email } = reduxState.user.data);
    (phone = reduxState.user.data.contact.dayTelephone);
    ({ state } = reduxState.user.data.identity.primaryAddress);
  } else {
    ({
      firstName, lastName, email, phone, state,
    } = reduxState.indicateInterestForm.indicateInterest);
  }
  dispatch({ type: INDICATE_INTEREST, offerId });
  let response;
  try {
    response = await callWebApi(
      'POST',
      replacePlaceholders(API_OFFERING_INDICATE_INTEREST, { offerId }),
      {
        firstName,
        lastName,
        email,
        phoneNumber: phone,
        stateOfResidence: state,
        investmentRange,
        userId,
      },
      authToken,
    );
    dispatch({
      type: INDICATE_INTEREST_SUCCESSFUL,
      offerId,
    });
  } catch (err) {
    dispatch({
      type: INDICATE_INTEREST_FAILURE,
      error: err,
      offerId,
    });
    throw err;
  }
  return { response };
};

export const cancelIndication = offerId => async (dispatch, getState) => {
  dispatch({ type: CANCEL_INDICATION, offerId });
  const state = getState();
  const { authToken } = state;
  const { email } = state.user.data;
  let response;
  try {
    response = await callWebApi(
      'DELETE',
      replacePlaceholders(API_OFFERING_INDICATE_INTEREST, { offerId }),
      {
        email,
      },
      authToken,
    );
    dispatch({ type: CANCEL_INDICATION_SUCCESSFUL, offerId });
  } catch (err) {
    dispatch({ type: CANCEL_INDICATION_FAILURE, error: err, offerId });
    throw err;
  }
  return { response };
};

export const cancelIndicationById = token => async (dispatch) => {
  dispatch({ type: CANCEL_INDICATION, token });
  let response;
  try {
    response = await callWebApi(
      'DELETE',
      replacePlaceholders(API_OFFERING_WATCH_CANCEL_INDICATION, { token }),
    );
    dispatch({ type: CANCEL_INDICATION_SUCCESSFUL, token });
  } catch (err) {
    dispatch({ type: CANCEL_INDICATION_FAILURE, error: err, token });
    throw err;
  }
  return { response };
};



// WEBPACK FOOTER //
// ./src/actions/indicateInterest.js